let pending = false;

function autoGiftWrapper() {
  return document.querySelector('.cart-items__wrapper[data-auto-gift-action]');
}

async function refreshCartSections(source) {
  const sectionIds = [];
  document.querySelectorAll('cart-items-component').forEach((item) => {
    if (item instanceof HTMLElement && item.dataset.sectionId) {
      sectionIds.push(item.dataset.sectionId);
    }
  });

  let sections = {};
  if (sectionIds.length) {
    const sectionsRes = await fetch(`/?sections=${sectionIds.join(',')}`);
    sections = await sectionsRes.json();
  }

  document.dispatchEvent(
    new CustomEvent('cart:update', {
      bubbles: true,
      detail: { data: { source, sections } },
    })
  );
}

async function runAutoGiftCheck() {
  if (pending) return;

  const wrapper = autoGiftWrapper();
  const action = wrapper?.getAttribute('data-auto-gift-action');
  if (!action) return;

  pending = true;

  try {
    if (action.startsWith('add:')) {
      const variantId = action.slice(4);
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1, properties: { _auto_gift: 'true' } }),
      });
      if (!res.ok) return;
    } else if (action.startsWith('remove:')) {
      const key = action.slice(7);
      if (!key) return;
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 }),
      });
      if (!res.ok) return;
    } else {
      return;
    }

    await refreshCartSections('auto-gift');
  } catch (err) {
    console.error('Kon automatisch cadeau niet bijwerken:', err);
  } finally {
    pending = false;
  }
}

// A customer removing the gift line by hand should never have it silently
// come back on the next cart re-render. Fires alongside (not instead of) the
// theme's own remove handling, since it only touches cart attributes.
document.addEventListener(
  'click',
  (e) => {
    if (!(e.target instanceof Element)) return;
    const removeBtn = e.target.closest('.cart-items__remove');
    if (!removeBtn) return;
    if (!removeBtn.closest('[data-is-gift]')) return;

    fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { _auto_gift_removed: 'true' } }),
    }).catch((err) => console.error('Kon cadeau niet als verwijderd markeren:', err));
  },
  true
);

document.addEventListener('cart:update', (e) => {
  if (e.detail?.data?.source === 'auto-gift') return;
  runAutoGiftCheck();
});

runAutoGiftCheck();
